import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  DoCheck,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from "@angular/core";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {Service} from "../../../models/service.model";
import {NgxPermissionsService} from "ngx-permissions";


require('./services-table.scss');
@Component({
  standalone: false,
  selector: 'app-services-table',
  templateUrl: './services-table.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.Emulated
})
export class ServicesTableComponent implements OnInit, OnChanges, AfterViewInit, DoCheck {

  @Input() services: Service[];
  @Input() isLoading: boolean;
  @Input() isInitialized: boolean;
  @Input() columns: any;
  @Input() isScrollable: boolean;
  @Input() hideActions: boolean;
  @Input() selectedIds: string[];
  @Input() dynamicColumns: any;
  @Input() packageDynamicColumns: any;
  @Input() sortType: any;

  // @Output() reloadEvent = new EventEmitter<any>();
  @Output() fetchNextEvent = new EventEmitter<null>();
  @Output() selectedIdsChangeEvent = new EventEmitter<string[]>();
  @Output() sortTypeChangeEvent = new EventEmitter<string>();
  @Output() editAddressEvent = new EventEmitter<string>();
  @Output() filterByTypeEvent = new EventEmitter<any>();

  // onFilterByType: Function;

  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  public displayAsItems: any;
  public selectedKeys: any;
  public asceDescIconsMap: any;
  public hasFleetManagementPermission: boolean;
  public hasPricePlanPermission: boolean;
  public enabledDynamicColumns: any;
  public enabledPackageDynamicColumns: any;
  public configZoneId: string;
  public siteDistanceLargeUnit: string;
  public lastSelectedIndex: number;
  public readonly skeletonRows: undefined[] = Array.from({length: 10});

  constructor(@Inject(NgxPermissionsService) private permissionsService: NgxPermissionsService, @Inject('splitService') private splitService,
              @Inject('$timeout') private $timeout) {
    this.getScreenSize();
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.displayAsItems = window.innerWidth < 600;
  }

  ngDoCheck() {
    this.cdkVirtualScrollViewport?.checkViewportSize();
  }

  ngOnInit() {
    this.configZoneId = this.splitService.getTimeZone();

    this.siteDistanceLargeUnit = this.splitService.getSiteDistanceLargeUnit(true);
    this.asceDescIconsMap = {
      asc: 'sort-asc',
      desc: 'sort-desc',
      undefined: 'sort'
    };

    this._initSelectedKeys();
    this._setEnabledColumns();


    this.permissionsService.hasPermission('fleetManagement.vehicles.list').then((hasPermission) => {
      this.hasFleetManagementPermission = hasPermission;
    });

    this.permissionsService.hasPermission('priceplan.list').then((hasPermission) => {
      this.hasPricePlanPermission = hasPermission;
    });
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.services) {
      this.cdkVirtualScrollViewport?.checkViewportSize();
    }

    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this._initSelectedKeys();
    }

    if (changes.dynamicColumns && !changes.dynamicColumns.isFirstChange() ||
      changes.packageDynamicColumns && !changes.packageDynamicColumns.isFirstChange()) {
      this._setEnabledColumns();
    }
  }

  private _setEnabledColumns() {
    this.enabledDynamicColumns = this.dynamicColumns?.filter((c) => c.enabled) || [];
    this.enabledPackageDynamicColumns = this.packageDynamicColumns?.filter((c) => c.enabled) || [];
  }

  getNextBatch() {
    if (this.cdkVirtualScrollViewport.measureScrollOffset('bottom') < 50) {
      this.fetchNextEvent.emit();
    }
  }

  ngAfterViewInit(): void {
    const div1 = document.getElementById('header');
    const div2 = document.querySelectorAll('.cdk-virtual-scroll-viewport')[0];


    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    })
  }

  toggleDelivery(serviceId: string, event) {
    const serviceIdIndex = this.services.findIndex(s => s.id === serviceId);

    const selectedKeysCopy = {...this.selectedKeys};

    if (event.shiftKey && this.lastSelectedIndex !== undefined) {
      if (!this.selectedKeys[serviceId]) {
        const start = Math.min(this.lastSelectedIndex, serviceIdIndex);
        const end = Math.max(this.lastSelectedIndex, serviceIdIndex);
        const services = this.services.slice(start, end + 1);

        for (let i = 0; i < services.length; i++) {
          selectedKeysCopy[services[i].id] = true;
        }
      } else {

        const services = this.services.slice(serviceIdIndex);

        for (let i = 0; i < services.length; i++) {
          selectedKeysCopy[services[i].id] = false;
        }
      }

      this.selectedKeys = selectedKeysCopy;
      this.changeSelectedIds();

    } else {
      selectedKeysCopy[serviceId] = !selectedKeysCopy[serviceId];
      this.selectedKeys = selectedKeysCopy;
      this.changeSelectedIds();
    }

    this.lastSelectedIndex = serviceIdIndex;

  }


  onSortTypeChange(name: string) {
    this.sortTypeChangeEvent.emit(name);
  }

  onEditAddress(addressId: string) {
    this.editAddressEvent.emit(addressId);
  }

  onFilterByType($event) {
    this.filterByTypeEvent.emit($event);
  }

  trackById(service: any): number {
    return service.id;
  }

  private _initSelectedKeys() {
    this.selectedKeys = {};
    this.selectedIds.forEach((selectedId: string) => {
      this.selectedKeys[selectedId] = true;
    })
  }

  private changeSelectedIds() {
    const selectedIds = [];

    for (const serviceId in this.selectedKeys) {
      if (this.selectedKeys[serviceId]) {
        selectedIds.push(serviceId);
      }
    }

    this.selectedIdsChangeEvent.emit(selectedIds);
  }

}
